import React from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { z } from 'zod';

import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { AssignmentStrategyForm } from '~/packages/loanProduct/ui/assignmentStrategy/assignmentStrategyForm/AssignmentStrategyForm';

// Types
const RouteParamsStruct = z.object({
  implementationId: z.string({ message: 'Missing URL parameter' }),
});

// Fragments
const RouteBase = () => {
  const params = useParams();
  const { implementationId } = RouteParamsStruct.parse(params);

  return (
    <AssignmentStrategyForm
      backUrl="/settings/assignment-strategy"
      implementationId={implementationId}
      readOnly={false}
    />
  );
};

// Exports
export const Route = () => (
  <RouteErrorBoundary
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <Navigate to="/settings/assignment-strategy" />;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
